// Shared main-menu backgrounds (home screen cards + nav items)
import menuBg1 from "./assets/images/bg-1.webp";
import menuBg2 from "./assets/images/bg-2.webp";
import menuBg3 from "./assets/images/bg-3.webp";
import shopCardBg from "./assets/images/shop-card-bg.webp";
import blueBg from "./assets/images/blue-bg.png";
import grayBg from "./assets/images/gray-bg.png";

// Home
import referralBarBg from "./sections/home/assets/images/referral-bar-bg.webp";

// Profile
import bankCardBg from "./sections/profile/assets/images/bank-card-bg.webp";
import cashCardBg from "./sections/profile/assets/images/cash-card-bg.webp";
import profileGrayBg from "./sections/profile/assets/images/gray-bg.webp";
import hoursPlayedBg from "./sections/profile/assets/images/hours-played-bg.webp";
import levelCardBg from "./sections/profile/assets/images/level-card-bg.webp";
import marriageCardBg from "./sections/profile/assets/images/marriage-card-bg.webp";
import nameCardBg from "./sections/profile/assets/images/name-card-bg.webp";
import organizationCardBg from "./sections/profile/assets/images/organization-card-bg.webp";
import rangBg from "./sections/profile/assets/images/rang-bg.webp";
import recoilCardBg from "./sections/profile/assets/images/recoil-card-bg.webp";
import statisticsCardBg from "./sections/profile/assets/images/statistics-card-bg.webp";
import statusCardBg from "./sections/profile/assets/images/status-card-bg.webp";

// Missions
import missionsBg from "./sections/missions/assets/images/bg.webp";
import missionCardBg from "./sections/missions/assets/images/mission-card-bg.webp";
import missionCardCompletedBg from "./sections/missions/assets/images/mission-card-completed-bg.webp";

// Shop (grid + featured cards)
import specialOfferBg from "./sections/shop/assets/images/special-offer-bg.webp";
import shopContainerBg from "./sections/shop/assets/images/container-bg.webp";
import beginnerBg from "./sections/shop/assets/images/beginner-package-bg.webp";
import vipCardBg from "./sections/shop/assets/images/vip-card-bg.webp";
import clotchesBg from "./sections/shop/assets/images/clotches-bg.webp";
import backpacksShopBg from "./sections/shop/assets/images/backpacks-bg.webp";
import organizationsShopBg from "./sections/shop/assets/images/organizations-bg.webp";
import backpackSkinsBg from "./sections/shop/assets/images/backpack-skins-bg.webp";
import premiumVehicleBg from "./sections/shop/assets/images/premium-vehicle-bg.webp";
import moneyPackageShopBg from "./sections/shop/assets/images/money-package-bg.webp";
import otherShopBg from "./sections/shop/assets/images/other-bg.webp";

// VIP
import diamondBg from "./sections/vip/assets/images/background/diamond-bg.webp";
import goldBg from "./sections/vip/assets/images/background/gold-bg.webp";
import silverBg from "./sections/vip/assets/images/background/silver-bg.webp";

// Containers
import containersCardBg from "./sections/containers/assets/images/card-bg.webp";
import containersCardBgHover from "./sections/containers/assets/images/card-bg-hover.webp";
import containersListBg from "./sections/containers/assets/images/containers-bg-2.webp";
import rarityCardGold   from "./sections/containers/assets/images/rarity-card-bg/gold.png";
import rarityCardRed    from "./sections/containers/assets/images/rarity-card-bg/red.png";
import rarityCardPink   from "./sections/containers/assets/images/rarity-card-bg/pink.png";
import rarityCardPurple from "./sections/containers/assets/images/rarity-card-bg/purple.webp";
import rarityCardBlue   from "./sections/containers/assets/images/rarity-card-bg/blue.webp";
import rarityCardWhite  from "./sections/containers/assets/images/rarity-card-bg/white.png";
import raritySpinGold   from "./sections/containers/assets/images/rarity-spin-bg/gold.png";
import raritySpinRed    from "./sections/containers/assets/images/rarity-spin-bg/red.png";
import raritySpinPink   from "./sections/containers/assets/images/rarity-spin-bg/pink.png";
import raritySpinPurple from "./sections/containers/assets/images/rarity-spin-bg/purple.webp";
import raritySpinBlue   from "./sections/containers/assets/images/rarity-spin-bg/blue.webp";
import raritySpinWhite  from "./sections/containers/assets/images/rarity-spin-bg/white.png";

// Backpacks
import backpackBg1 from "./sections/backpacks/assets/images/bg-1.webp";
import backpackBg2 from "./sections/backpacks/assets/images/bg-2.webp";
import backpackBg3 from "./sections/backpacks/assets/images/bg-3.webp";

// Organizations
import orgDefaultBg from "./sections/organizations/assets/images/default-bg.webp";
import orgHighlightedBg from "./sections/organizations/assets/images/highlighted-bg.webp";

// Vouchers
import voucher10 from "./sections/vouchers/assets/images/voucher_ap_10.png";
import voucher25 from "./sections/vouchers/assets/images/voucher_ap_25.png";
import voucher50 from "./sections/vouchers/assets/images/voucher_ap_50.png";
import voucher100 from "./sections/vouchers/assets/images/voucher_ap_100.png";

// Vehicles — shared by Animatii and Haine too
import vehicleCardBg from "./sections/vehicles/assets/images/card-bg.webp";

// Other
import otherCardBg from "./sections/other/assets/images/card-bg.webp";

// Settings
import settingCardBg from "./sections/settings/assets/images/setting-card-bg.webp";
import settingsIconBg from "./sections/settings/assets/images/icon-bg.webp";

// Money packages
import moneyPackageBg from "./sections/money-packages/assets/images/bg.webp";
import moneyPackageWideBg from "./sections/money-packages/assets/images/wide-bg.webp";

// Referral
import myRewardsBg from "./sections/referral/assets/images/my-rewards-bg.webp";
import playerCardBg from "./sections/referral/assets/images/player-card-bg.webp";
import referredPlayersBg from "./sections/referral/assets/images/referred-players-bg.webp";
import rewardDefaultBg from "./sections/referral/assets/images/reward-default-bg.webp";
import rewardClaimedBg from "./sections/referral/assets/images/reward-claimed-bg.webp";

export const ALL_SECTION_IMAGES: string[] = [
  // Shared
  menuBg1, menuBg2, menuBg3, shopCardBg, blueBg, grayBg,
  // Home
  referralBarBg,
  // Profile
  bankCardBg, cashCardBg, profileGrayBg, hoursPlayedBg, levelCardBg,
  marriageCardBg, nameCardBg, organizationCardBg, rangBg,
  recoilCardBg, statisticsCardBg, statusCardBg,
  // Missions
  missionsBg, missionCardBg, missionCardCompletedBg,
  // Shop
  specialOfferBg, shopContainerBg, beginnerBg, vipCardBg, clotchesBg,
  backpacksShopBg, organizationsShopBg, backpackSkinsBg,
  premiumVehicleBg, moneyPackageShopBg, otherShopBg,
  // VIP
  diamondBg, goldBg, silverBg,
  // Containers
  containersCardBg, containersCardBgHover, containersListBg,
  rarityCardGold, rarityCardRed, rarityCardPink, rarityCardPurple, rarityCardBlue, rarityCardWhite,
  raritySpinGold, raritySpinRed, raritySpinPink, raritySpinPurple, raritySpinBlue, raritySpinWhite,
  // Backpacks
  backpackBg1, backpackBg2, backpackBg3,
  // Organizations
  orgDefaultBg, orgHighlightedBg,
  // Vouchers
  voucher10, voucher25, voucher50, voucher100,
  // Vehicles / Animatii / Haine
  vehicleCardBg,
  // Other
  otherCardBg,
  // Settings
  settingCardBg, settingsIconBg,
  // Money packages
  moneyPackageBg, moneyPackageWideBg,
  // Referral
  myRewardsBg, playerCardBg, referredPlayersBg, rewardDefaultBg, rewardClaimedBg,
];
